"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ui = require("@alycecom/ui");

var _hooks = require("@alycecom/hooks");

var _utils = require("@alycecom/utils");

var _reactHookForm = require("react-hook-form");

var _yup = require("@hookform/resolvers/yup");

var _material = require("@mui/material");

var _commonData = require("../../Shared/store/commonData");

var selectors = _interopRequireWildcard(require("../store/personalTemplateSettings.selectors"));

var _personalTemplateSettings2 = require("../store/personalTemplateSettings.schemas");

var _hooks2 = require("../../CampaignSettings/hooks");

var _features = require("../../Shared/store/features");

var _components = require("../../CampaignSettings/components");

var _TemplateMessageField = require("./TemplateMessageField");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var emptyTemplate = {
  name: '',
  subject: '',
  message: ''
};

var TemplateItem = function TemplateItem(_ref) {
  var id = _ref.id,
      onSave = _ref.onSave,
      onDelete = _ref.onDelete,
      edit = _ref.edit,
      onToggleEdit = _ref.onToggleEdit;

  var _useTheme = (0, _material.useTheme)(),
      palette = _useTheme.palette;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isDeleteOpen = _useState2[0],
      setIsDeleteOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isDeleteDefaultOpen = _useState4[0],
      setIsDeleteDefaultOpen = _useState4[1];

  var isLoading = (0, _reactRedux.useSelector)(selectors.getIsLoading);
  var template = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return selectors.getTemplateById(id);
  }, [id])) || emptyTemplate;
  var messageLimitMax = (0, _reactRedux.useSelector)(_commonData.CommonData.selectors.getEmailCharLimit);
  var externalErrors = (0, _reactRedux.useSelector)(selectors.getErrors);
  var giftInvitationTemplates = (0, _hooks2.useGiftInvitationTemplates)();
  var allGiftInvitationTemplates = giftInvitationTemplates.useAll();
  var hasManageProspectingCampaignTemplate = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return _features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.MANAGE_PROSPECTING_CAMPAIGN_TEMPLATE);
  }, []));
  var resolver = (0, _react.useMemo)(function () {
    return (0, _yup.yupResolver)((0, _personalTemplateSettings2.createTemplateFormSchema)({
      messageLimitMax
    }));
  }, [messageLimitMax]);

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'all',
    resolver,
    defaultValues: {
      name: template.name,
      subject: template.subject,
      message: template.message
    },
    context: {
      messageLimitMax
    }
  }),
      handleSubmit = _useForm.handleSubmit,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isDirty = _useForm$formState.isDirty,
      reset = _useForm.reset,
      register = _useForm.register,
      control = _useForm.control,
      setError = _useForm.setError;

  var _register = register('name'),
      nameRef = _register.ref,
      nameControlProps = (0, _objectWithoutProperties2.default)(_register, ["ref"]);

  var isCreateMode = !id;
  var isEditMode = edit || isCreateMode;
  var isSaveDisabled = isLoading;
  (0, _hooks.useExternalErrors)(setError, externalErrors);
  var handleEditButtonClick = (0, _react.useCallback)(function () {
    onToggleEdit(id);
  }, [id, onToggleEdit]);
  var handleSave = (0, _react.useCallback)(function (form) {
    var data = id ? _objectSpread(_objectSpread({}, form), {}, {
      id
    }) : form;
    onSave(data);
  }, [id, onSave]);
  var handleDelete = (0, _react.useCallback)(function () {
    if (hasManageProspectingCampaignTemplate) {
      giftInvitationTemplates.fetchData(id);
    } else {
      setIsDeleteOpen(true);
    }
  }, [giftInvitationTemplates, hasManageProspectingCampaignTemplate, id]);
  var handleCloseConfirmationDialogs = (0, _react.useCallback)(function () {
    setIsDeleteOpen(false);
    setIsDeleteDefaultOpen(false);
    giftInvitationTemplates.clearData();
  }, [giftInvitationTemplates]);
  var handleDiscard = (0, _react.useCallback)(function () {
    var message = template.message,
        subject = template.subject,
        name = template.name;
    reset({
      message,
      subject,
      name
    });
  }, [reset, template]);
  var handleDeleteConfirmation = (0, _react.useCallback)(function () {
    handleCloseConfirmationDialogs();
    onDelete(id);
  }, [handleCloseConfirmationDialogs, id, onDelete]);
  var handleDeleteCancel = (0, _react.useCallback)(function () {
    handleCloseConfirmationDialogs();
  }, [handleCloseConfirmationDialogs]);
  (0, _react.useEffect)(function () {
    var isElementToDelete = giftInvitationTemplates.isFulfilled && giftInvitationTemplates.selectedId === id;
    var isDefaultTemplateToDelete = hasManageProspectingCampaignTemplate && isElementToDelete && allGiftInvitationTemplates.length;
    var isTemplateToDelete = isElementToDelete && !allGiftInvitationTemplates.length;

    if (isDefaultTemplateToDelete) {
      setIsDeleteDefaultOpen(true);
    } else if (isTemplateToDelete) {
      setIsDeleteOpen(true);
    }
  }, [hasManageProspectingCampaignTemplate, allGiftInvitationTemplates, giftInvitationTemplates.isFulfilled, giftInvitationTemplates.selectedId, id]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/_react.default.createElement(_components.DeleteDefaultTemplateConfirmation, {
    isOpen: isDeleteDefaultOpen,
    allGiftInvitationTemplates: allGiftInvitationTemplates,
    onDiscard: handleDeleteCancel,
    onSubmit: handleDeleteConfirmation
  }), !isCreateMode && /*#__PURE__*/_react.default.createElement(_ui.ModalConfirmationMessage, {
    width: "100%",
    variant: "warning",
    icon: "times",
    title: "Delete personal template",
    submitButtonText: "Delete",
    cancelButtonText: "Cancel",
    isOpen: isDeleteOpen,
    onSubmit: handleDeleteConfirmation,
    onDiscard: handleDeleteCancel,
    backdropStyles: {
      top: 0
    }
  }, "Are you sure you wish to delete this template?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    fontWeight: 700
  }, isCreateMode ? 'Create new template' : template.name)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 100
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    fullWidth: true,
    "data-testid": "personalTemplates.templateItemEditToggle-".concat(template.name ? (0, _utils.underscoreCase)(template.name) : 'new'),
    onClick: handleEditButtonClick,
    className: "Button-Link",
    variant: "outlined"
  }, isEditMode ? 'Close' : 'Modify'))), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    component: "form",
    in: isEditMode,
    onSubmit: handleSubmit((0, _utils.applyEach)([handleSave, reset])),
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    width: 3 / 7
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({
    fullWidth: true
  }, nameControlProps, {
    inputRef: nameRef,
    error: !!errors.name,
    helperText: errors.name && errors.name.message,
    variant: "outlined",
    name: "name",
    label: "Template name"
  }))), /*#__PURE__*/_react.default.createElement(_ui.Divider, {
    mt: 4,
    mb: 2
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 3 / 7
  }, /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "subject",
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/_react.default.createElement(_TemplateMessageField.TemplateMessageField, (0, _extends2.default)({}, field, {
        textFieldProps: {
          error: !!errors.subject,
          helperText: errors.subject && errors.subject.message,
          label: 'Message subject',
          multiline: false
        }
      }));
    }
  })), /*#__PURE__*/_react.default.createElement(_ui.HtmlTip, {
    mt: 2
  }, "Tip: If you have not integrated your email service, this message subject will be used in ALL EMAILS sent through Alyce. This includes your initial email (if you're sending an invite through email) and all follow up emails that are sent by Alyce."), /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: "message",
    control: control,
    render: function render(_ref3) {
      var field = _ref3.field;
      return /*#__PURE__*/_react.default.createElement(_TemplateMessageField.TemplateMessageField, (0, _extends2.default)({}, field, {
        error: errors.message && errors.message.message,
        charsLimit: messageLimitMax
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "save"
    }),
    disabled: isSaveDisabled,
    variant: "primary",
    width: "auto",
    type: "submit"
  }, "Save"), isDirty && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: _material.Button,
    onClick: handleDiscard,
    ml: 2,
    className: "Button-Link",
    variant: "outlined"
  }, "Discard changes")), !isCreateMode && /*#__PURE__*/_react.default.createElement(_ui.BaseButton, {
    width: "auto",
    onClick: handleDelete,
    variant: "outlined",
    color: palette.error.main,
    hoverColor: palette.error.light,
    borderColor: palette.error.main,
    disabled: isLoading
  }, "Delete template"))), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !isEditMode,
    unmountOnExit: true
  }, template.message));
};

TemplateItem.propTypes = {
  id: _propTypes.default.number,
  onSave: _propTypes.default.func.isRequired,
  onDelete: _propTypes.default.func,
  edit: _propTypes.default.bool,
  onToggleEdit: _propTypes.default.func.isRequired
};
TemplateItem.defaultProps = {
  id: null,
  onDelete: null,
  edit: false
};

var _default = /*#__PURE__*/(0, _react.memo)(TemplateItem);

exports.default = _default;